import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import {complianceRequirementDetailUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {ComplianceRequirement} from "~/pages/supplier-360/types/Supplier360Types";

/**
 * One compliance record (`GET supplier_360/compliance_requirement/{id}/`, §2.8) — the detail page.
 * Shares the requirement prefix, so an edit or an evidence upload (which flips `state`) refreshes it.
 */
export function useComplianceRequirementQuery(requirementId: number | undefined) {
    const url = complianceRequirementDetailUrl(requirementId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<ComplianceRequirement>(url)).data,
        enabled: Boolean(requirementId),
    });
}
